// ============================================================
// cf-select.js � Enhanced dropdown (single / multi-select)
//
// Dependencies: jQuery (available globally)
//
// Features:
//   - Single select with icon/avatar + title + description
//   - Multi-select with checkbox tags + select all
//   - Search with configurable min chars
//   - Cascade (dynamic N-level parent ? child)
//   - Remote data via ApiResponse<T> pattern
//   - Static data
//
// Usage:
//   CF.select.init('#mySelect', {
//       multiple: false,
//       searchable: true,
//       searchMinChars: 3,
//       placeholder: 'Select...',
//       data: [
//           { value: '1', text: 'Engineering', icon: 'fa-solid fa-code', description: 'Software team' },
//           { value: '2', text: 'John Doe', avatar: '/img/john.jpg', description: 'Admin' }
//       ],
//       // OR remote:
//       remote: {
//           url: '/api/v1/departments',
//           searchParam: 'search',    // query param name
//           parentParam: 'parentId',  // for cascade
//           map: function(item) {     // optional: map API item ? option
//               return { value: item.id, text: item.name };
//           }
//       },
//       cascade: {
//           parentId: 'countrySelect', // CF.select instance ID of parent
//       },
//       onChange: function(value, instance) { }
//   });
// ============================================================

window.CF = window.CF || {};

(function ($) {
    'use strict';

    var _registry = {};
    var _counter = 0;

    CF.select = {

        // ? Main init ���������������������������
        init: function (selector, opts) {
            var el = document.querySelector(selector);
            if (!el) return null;

            opts = $.extend({
                multiple:       false,
                searchable:     false,
                searchMinChars: 0,
                placeholder:    'Select...',
                data:           null,
                remote:         null,
                cascade:        null,
                onChange:        null,
                disabled:       false,
                selectAll:      true,   // only for multiple
                freeTag:        false   // type + Enter to create tags (no dropdown)
            }, opts);

            var uid = 'cfs-' + (++_counter);

            var ctx = {
                uid:           uid,
                el:            el,
                opts:          opts,
                selectedValues: [],
                optionsData:   [],
                isOpen:        false,
                isLoading:     false,
                searchQuery:   '',
                wrap:          null,
                trigger:       null,
                dropdown:      null,
                searchInput:   null,
                optionsList:   null,
                hidden:        null
            };

            _registry[uid] = ctx;

            _buildDOM(ctx);
            _attachEvents(ctx);

            // Load initial data
            if (opts.data) {
                ctx.optionsData = _normalizeData(opts.data);
                _renderOptions(ctx);
            } else if (opts.remote && !opts.cascade) {
                _fetchRemote(ctx, '');
            } else if (el.tagName === 'SELECT' && !opts.freeTag) {
                // Fallback: read existing <option> elements from the native <select>
                var nativeOpts = [];
                $(el).find('option').each(function () {
                    if (!this.value && !this.textContent.trim()) return;
                    if (!this.value) return; // skip placeholder "All" with empty value
                    nativeOpts.push({
                        value: this.value,
                        text:  this.textContent.trim()
                    });
                });
                if (nativeOpts.length) {
                    ctx.optionsData = _normalizeData(nativeOpts);
                    _renderOptions(ctx);
                }
            }

            // Cascade: listen to parent
            if (opts.cascade && opts.cascade.parentId) {
                var parentCtx = _findByOriginalId(opts.cascade.parentId);
                if (parentCtx) {
                    var origOnChange = parentCtx.opts.onChange;
                    parentCtx.opts.onChange = function (val, inst) {
                        if (typeof origOnChange === 'function') origOnChange(val, inst);
                        _onParentChange(ctx, val);
                    };
                }
            }

            // Pre-select from original <select> value
            if (el.tagName === 'SELECT') {
                var preselected = [];
                $(el).find('option:selected').each(function () {
                    if (this.value) preselected.push(this.value);
                });
                if (preselected.length) {
                    ctx.selectedValues = preselected;
                    _syncDisplay(ctx);
                }
            }

            return { uid: uid };
        },

        // ?? Public API ??????????????????????????????????
        getValue: function (uid) {
            var ctx = _registry[uid];
            if (!ctx) return null;
            return (ctx.opts.multiple || ctx.opts.freeTag) ? ctx.selectedValues.slice() : (ctx.selectedValues[0] || null);
        },

        setValue: function (uid, values) {
            var ctx = _registry[uid];
            if (!ctx) return;
            if (!Array.isArray(values)) values = [values];
            ctx.selectedValues = values.filter(function (v) { return v !== null && v !== undefined && v !== ''; });
            _syncDisplay(ctx);
            _syncHidden(ctx);
            _triggerChange(ctx);
        },

        clear: function (uid) {
            var ctx = _registry[uid];
            if (ctx && ctx.opts.freeTag) {
                ctx.optionsData = [];
            }
            CF.select.setValue(uid, []);
        },

        destroy: function (uid) {
            var ctx = _registry[uid];
            if (!ctx) return;
            if (ctx.wrap && ctx.wrap.parentNode) {
                ctx.el.style.display = '';
                ctx.wrap.parentNode.removeChild(ctx.wrap);
            }
            delete _registry[uid];
        },

        setData: function (uid, data) {
            var ctx = _registry[uid];
            if (!ctx) return;
            ctx.optionsData = _normalizeData(data);
            ctx.selectedValues = [];
            _renderOptions(ctx);
            _syncDisplay(ctx);
            _syncHidden(ctx);
        },

        /**
         * Sync options and selected value from the native <select> element
         * into an existing CF.select instance.
         * Use after manually populating a native <select> via innerHTML / appendChild
         * and needing to reflect those changes in the CF.select UI.
         * @param {string} uid � CF.select instance UID returned by init()
         */
        refreshFromNative: function (uid) {
            var ctx = _registry[uid];
            if (!ctx || !ctx.el) return;

            var data = [];
            var opts = ctx.el.options;
            for (var i = 0; i < opts.length; i++) {
                if (!opts[i].value) continue;
                data.push({ value: opts[i].value, text: opts[i].textContent });
            }

            ctx.optionsData = _normalizeData(data);
            _renderOptions(ctx);

            var selectedVal = ctx.el.value || null;
            ctx.selectedValues = selectedVal ? [selectedVal] : [];
            _syncDisplay(ctx);
            _syncHidden(ctx);
        }
    };

    // ?? Normalize data ??????????????????????????????
    function _normalizeData(arr) {
        if (!arr) return [];
        return arr.map(function (item) {
            if (typeof item === 'string') return { value: item, text: item };
            return {
                value:       String(item.value != null ? item.value : ''),
                text:        item.text || item.label || '',
                icon:        item.icon || null,
                avatar:      item.avatar || null,
                description: item.description || null,
                disabled:    !!item.disabled
            };
        });
    }

    // ?? Find ctx by original element ID ?????????????
    function _findByOriginalId(id) {
        for (var uid in _registry) {
            if (_registry[uid].el.id === id) return _registry[uid];
        }
        return null;
    }

    // ?? Build DOM ???????????????????????????????????
    function _buildDOM(ctx) {
        var opts = ctx.opts;

        // Hide original element
        ctx.el.style.display = 'none';

        // Wrapper
        var wrap = document.createElement('div');
        wrap.className = 'cf-select-wrap';
        wrap.setAttribute('data-uid', ctx.uid);
        ctx.el.parentNode.insertBefore(wrap, ctx.el.nextSibling);
        ctx.wrap = wrap;

        // Hidden input for form submission (use original name)
        var hiddenName = ctx.el.getAttribute('name') || ctx.el.id || '';
        if (opts.multiple || opts.freeTag) {
            // For multi / freeTag, we'll sync multiple hidden inputs
            ctx.hiddenContainer = document.createElement('div');
            ctx.hiddenContainer.style.display = 'none';
            wrap.appendChild(ctx.hiddenContainer);
        } else {
            var hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.name = hiddenName;
            wrap.appendChild(hidden);
            ctx.hidden = hidden;
        }

        // FreeTag mode: inline input with tags, no dropdown
        if (opts.freeTag) {
            var trigger = document.createElement('div');
            trigger.className = 'cf-select-trigger cf-freetag-trigger';

            var freeInput = document.createElement('input');
            freeInput.type = 'text';
            freeInput.className = 'cf-freetag-input';
            freeInput.placeholder = opts.placeholder;
            trigger.appendChild(freeInput);

            wrap.appendChild(trigger);
            ctx.trigger = trigger;
            ctx.freeInput = freeInput;

            // No dropdown for freeTag
            var emptyDd = document.createElement('div');
            emptyDd.className = 'cf-select-dropdown';
            emptyDd.innerHTML = '<div class="cf-select-options"></div>';
            emptyDd.style.display = 'none';
            wrap.appendChild(emptyDd);
            ctx.dropdown = emptyDd;
            ctx.optionsList = emptyDd.querySelector('.cf-select-options');
            ctx.searchInput = null;
            return;
        }

        // Trigger
        var trigger = document.createElement('div');
        trigger.className = 'cf-select-trigger' + (opts.disabled ? ' disabled' : '');
        trigger.innerHTML =
            '<span class="cf-select-placeholder">' + _escHtml(opts.placeholder) + '</span>' +
            '<i class="fa-solid fa-chevron-down cf-select-arrow"></i>';
        wrap.appendChild(trigger);
        ctx.trigger = trigger;

        // Dropdown
        var dd = document.createElement('div');
        dd.className = 'cf-select-dropdown';

        var ddHtml = '';

        // Search
        if (opts.searchable) {
            var hint = opts.searchMinChars > 0
                ? 'Type at least ' + opts.searchMinChars + ' characters to search'
                : '';
            ddHtml +=
                '<div class="cf-select-search-wrap">' +
                    '<i class="fa-solid fa-magnifying-glass"></i>' +
                    '<input type="text" class="cf-select-search" placeholder="Search\u2026" />' +
                '</div>';
            if (hint) {
                ddHtml += '<div class="cf-select-search-hint">' + hint + '</div>';
            }
        }

        // Select all (multi only)
        if (opts.multiple && opts.selectAll) {
            ddHtml +=
                '<div class="cf-select-all-bar">' +
                    '<input type="checkbox" />' +
                    '<span>Select All</span>' +
                '</div>';
        }

        ddHtml += '<div class="cf-select-options"></div>';

        dd.innerHTML = ddHtml;
        wrap.appendChild(dd);
        ctx.dropdown = dd;
        ctx.searchInput = dd.querySelector('.cf-select-search');
        ctx.optionsList = dd.querySelector('.cf-select-options');
    }

    // ?? Attach events ???????????????????????????????
    function _attachEvents(ctx) {
        var opts = ctx.opts;

        // FreeTag mode: handle inline input
        if (opts.freeTag && ctx.freeInput) {
            $(ctx.freeInput).on('keydown', function (e) {
                if (e.key === 'Enter' || e.key === ',') {
                    e.preventDefault();
                    var val = this.value.trim().replace(/,+$/, '').trim();
                    if (val) {
                        var tags = val.split(/,\s*/);
                        tags.forEach(function (tag) {
                            tag = tag.trim();
                            if (tag) _addFreeTag(ctx, tag);
                        });
                        this.value = '';
                    }
                }
                // Backspace on empty input removes last tag
                if (e.key === 'Backspace' && !this.value && ctx.selectedValues.length) {
                    var lastVal = ctx.selectedValues[ctx.selectedValues.length - 1];
                    _deselectValue(ctx, lastVal);
                }
            });

            // Prevent clicks on trigger from stealing focus
            $(ctx.trigger).on('click', function () {
                ctx.freeInput.focus();
            });

            return;
        }

        // Toggle dropdown
        $(ctx.trigger).on('click', function () {
            if (opts.disabled) return;
            if (ctx.isOpen) _close(ctx);
            else _open(ctx);
        });

        // Search input
        if (ctx.searchInput) {
            var debounceTimer;
            $(ctx.searchInput).on('input', function () {
                var val = this.value.trim();
                clearTimeout(debounceTimer);
                debounceTimer = setTimeout(function () {
                    _onSearch(ctx, val);
                }, 250);
            });

            // Prevent trigger click when typing
            $(ctx.searchInput).on('click', function (e) { e.stopPropagation(); });
        }

        // Select all
        var allBar = ctx.dropdown.querySelector('.cf-select-all-bar');
        if (allBar) {
            $(allBar).on('click', function () {
                var cb = allBar.querySelector('input');
                var nowChecked = !cb.checked;
                cb.checked = nowChecked;
                _toggleSelectAll(ctx, nowChecked);
            });
        }

        // Click outside to close
        $(document).on('click.cfselect-' + ctx.uid, function (e) {
            if (!ctx.isOpen) return;
            if (!ctx.wrap.contains(e.target)) _close(ctx);
        });

        // Tag remove (delegated)
        $(ctx.trigger).on('click', '.cf-select-tag-remove', function (e) {
            e.stopPropagation();
            var val = $(this).closest('.cf-select-tag').attr('data-value');
            _deselectValue(ctx, val);
        });
    }

    // ?? Open / Close ????????????????????????????????
    function _open(ctx) {
        ctx.isOpen = true;
        ctx.trigger.classList.add('open');

        // Position dropdown using fixed coordinates to escape overflow containers
        _positionDropdown(ctx);

        ctx.dropdown.classList.add('open');

        if (ctx.searchInput) {
            ctx.searchInput.value = '';
            _showHint(ctx, true);
            setTimeout(function () { ctx.searchInput.focus(); }, 50);
        }

        _renderOptions(ctx);
    }

    function _positionDropdown(ctx) {
        var rect    = ctx.trigger.getBoundingClientRect();
        var dd      = ctx.dropdown;
        var ddMaxH  = 280;
        var gap     = 4;

        dd.style.position = 'fixed';
        dd.style.left     = rect.left + 'px';
        dd.style.width    = rect.width + 'px';
        dd.style.right    = 'auto';

        // Flip upward if not enough space below
        if (rect.bottom + ddMaxH + gap > window.innerHeight) {
            dd.style.top    = 'auto';
            dd.style.bottom = (window.innerHeight - rect.top + gap) + 'px';
        } else {
            dd.style.top    = (rect.bottom + gap) + 'px';
            dd.style.bottom = 'auto';
        }
    }

    function _close(ctx) {
        ctx.isOpen = false;
        ctx.trigger.classList.remove('open');
        ctx.dropdown.classList.remove('open');
        ctx.searchQuery = '';

        // Clear fixed positioning
        ctx.dropdown.style.position = '';
        ctx.dropdown.style.top      = '';
        ctx.dropdown.style.bottom   = '';
        ctx.dropdown.style.left     = '';
        ctx.dropdown.style.right    = '';
        ctx.dropdown.style.width    = '';
    }

    // ?? Search ??????????????????????????????????????
    function _onSearch(ctx, query) {
        ctx.searchQuery = query;

        if (ctx.opts.searchMinChars > 0 && query.length > 0 && query.length < ctx.opts.searchMinChars) {
            _showHint(ctx, true);
            ctx.optionsList.innerHTML = '';
            return;
        }
        _showHint(ctx, false);

        if (ctx.opts.remote) {
            _fetchRemote(ctx, query);
        } else {
            _renderOptions(ctx);
        }
    }

    function _showHint(ctx, show) {
        var hint = ctx.dropdown.querySelector('.cf-select-search-hint');
        if (hint) hint.style.display = show && ctx.opts.searchMinChars > 0 ? 'block' : 'none';
    }

    // ?? Remote fetch ????????????????????????????????
    function _fetchRemote(ctx, query) {
        var remote = ctx.opts.remote;
        if (!remote || !remote.url) return;

        ctx.isLoading = true;
        _renderLoading(ctx);

        var params = {};
        if (query) params[remote.searchParam || 'search'] = query;

        // Cascade: add parent value
        if (ctx.opts.cascade && ctx.opts.cascade.parentId) {
            var parentCtx = _findByOriginalId(ctx.opts.cascade.parentId);
            if (parentCtx) {
                var parentVal = parentCtx.selectedValues[0] || '';
                params[remote.parentParam || 'parentId'] = parentVal;
            }
        }

        var ajaxFn = (typeof CF !== 'undefined' && CF.auth && CF.auth.api) ? CF.auth.api : $.ajax;

        ajaxFn({
            url: remote.url,
            data: params,
            dataType: 'json'
        }).done(function (resp) {
            var items = [];
            if (resp && resp.success && Array.isArray(resp.data)) {
                items = resp.data;
            } else if (Array.isArray(resp)) {
                items = resp;
            }
            if (typeof remote.map === 'function') {
                items = items.map(remote.map);
            }
            ctx.optionsData = _normalizeData(items);
            ctx.isLoading = false;
            _renderOptions(ctx);
        }).fail(function () {
            ctx.optionsData = [];
            ctx.isLoading = false;
            _renderEmpty(ctx, 'Failed to load data');
        });
    }

    // ?? Cascade parent change ???????????????????????
    function _onParentChange(ctx, parentVal) {
        ctx.selectedValues = [];
        ctx.optionsData = [];
        _syncDisplay(ctx);
        _syncHidden(ctx);

        if (!parentVal) {
            _renderOptions(ctx);
            return;
        }

        if (ctx.opts.remote) {
            _fetchRemote(ctx, '');
        }
    }

    // ?? Render options ??????????????????????????????
    function _renderOptions(ctx) {
        if (ctx.isLoading) { _renderLoading(ctx); return; }

        var query = ctx.searchQuery.toLowerCase();
        var filtered = ctx.optionsData;

        if (query && !ctx.opts.remote) {
            filtered = filtered.filter(function (d) {
                return (d.text && d.text.toLowerCase().indexOf(query) >= 0) ||
                       (d.description && d.description.toLowerCase().indexOf(query) >= 0);
            });
        }

        if (!filtered.length) {
            _renderEmpty(ctx, query ? 'No results found' : 'No options available');
            return;
        }

        var html = '';
        filtered.forEach(function (d) {
            var isSelected = ctx.selectedValues.indexOf(d.value) >= 0;
            var cls = 'cf-select-option' + (isSelected ? ' selected' : '') + (d.disabled ? ' disabled' : '');

            var visual = '';
            if (d.avatar) {
                visual = '<img class="cf-opt-avatar" src="' + _escHtml(d.avatar) + '" alt="" />';
            } else if (d.icon) {
                visual = '<span class="cf-opt-icon"><i class="' + _escHtml(d.icon) + '"></i></span>';
            }

            var checkbox = ctx.opts.multiple
                ? '<input type="checkbox"' + (isSelected ? ' checked' : '') + (d.disabled ? ' disabled' : '') + ' />'
                : '';

            var content = '<div class="cf-opt-content">' +
                '<span class="cf-opt-title">' + _escHtml(d.text) + '</span>' +
                (d.description ? '<span class="cf-opt-desc">' + _escHtml(d.description) + '</span>' : '') +
            '</div>';

            html += '<div class="' + cls + '" data-value="' + _escHtml(d.value) + '">' +
                checkbox + visual + content + '</div>';
        });

        ctx.optionsList.innerHTML = html;

        // Attach click
        $(ctx.optionsList).find('.cf-select-option').on('click', function (e) {
            e.stopPropagation();
            var val = $(this).attr('data-value');
            var optData = filtered.find(function (d) { return d.value === val; });
            if (optData && optData.disabled) return;
            _onOptionClick(ctx, val);
        });

        // Sync select-all checkbox
        _syncSelectAllCheckbox(ctx);
    }

    function _renderLoading(ctx) {
        ctx.optionsList.innerHTML =
            '<div class="cf-select-loading"><i class="fa-solid fa-spinner"></i> Loading\u2026</div>';
    }

    function _renderEmpty(ctx, msg) {
        ctx.optionsList.innerHTML =
            '<div class="cf-select-empty"><i class="fa-regular fa-face-meh"></i> ' + _escHtml(msg) + '</div>';
    }

    // ?? Option click ????????????????????????????????
    function _onOptionClick(ctx, value) {
        if (ctx.opts.multiple) {
            var idx = ctx.selectedValues.indexOf(value);
            if (idx >= 0) ctx.selectedValues.splice(idx, 1);
            else ctx.selectedValues.push(value);
            _renderOptions(ctx);
        } else {
            ctx.selectedValues = [value];
            _close(ctx);
        }

        _syncDisplay(ctx);
        _syncHidden(ctx);
        _triggerChange(ctx);
    }

    // ?? Deselect (tag remove) ???????????????????????
    function _deselectValue(ctx, value) {
        var idx = ctx.selectedValues.indexOf(value);
        if (idx >= 0) ctx.selectedValues.splice(idx, 1);
        _syncDisplay(ctx);
        _syncHidden(ctx);
        _triggerChange(ctx);
        if (ctx.isOpen) _renderOptions(ctx);
    }

    // ?? Select all toggle ???????????????????????????
    function _toggleSelectAll(ctx, selectAll) {
        if (selectAll) {
            ctx.selectedValues = ctx.optionsData
                .filter(function (d) { return !d.disabled; })
                .map(function (d) { return d.value; });
        } else {
            ctx.selectedValues = [];
        }
        _renderOptions(ctx);
        _syncDisplay(ctx);
        _syncHidden(ctx);
        _triggerChange(ctx);
    }

    function _syncSelectAllCheckbox(ctx) {
        var allBar = ctx.dropdown.querySelector('.cf-select-all-bar');
        if (!allBar) return;
        var cb = allBar.querySelector('input');
        if (!cb) return;
        var enabled = ctx.optionsData.filter(function (d) { return !d.disabled; });
        cb.checked = enabled.length > 0 && enabled.every(function (d) {
            return ctx.selectedValues.indexOf(d.value) >= 0;
        });
    }

    // ? Sync display ������������������������
    function _syncDisplay(ctx) {
        // Remove existing content (keep arrow and freeInput)
        $(ctx.trigger).find('.cf-select-placeholder, .cf-select-single-value, .cf-select-tag').remove();

        // FreeTag mode
        if (ctx.opts.freeTag) {
            ctx.selectedValues.forEach(function (val) {
                var tag = document.createElement('span');
                tag.className = 'cf-select-tag';
                tag.setAttribute('data-value', val);
                tag.innerHTML = '<span>' + _escHtml(val) + '</span>' +
                    '<button type="button" class="cf-select-tag-remove"><i class="fa-solid fa-xmark"></i></button>';
                ctx.trigger.insertBefore(tag, ctx.freeInput);
            });
            // Toggle placeholder
            if (ctx.freeInput) {
                ctx.freeInput.placeholder = ctx.selectedValues.length ? '' : ctx.opts.placeholder;
            }
            return;
        }

        if (!ctx.selectedValues.length) {
            var ph = document.createElement('span');
            ph.className = 'cf-select-placeholder';
            ph.textContent = ctx.opts.placeholder;
            ctx.trigger.insertBefore(ph, ctx.trigger.querySelector('.cf-select-arrow'));
            return;
        }

        if (ctx.opts.multiple) {
            // Render tags
            var arrow = ctx.trigger.querySelector('.cf-select-arrow');
            ctx.selectedValues.forEach(function (val) {
                var d = _findOption(ctx, val);
                if (!d) return;
                var tag = document.createElement('span');
                tag.className = 'cf-select-tag';
                tag.setAttribute('data-value', val);
                tag.innerHTML = '<span>' + _escHtml(d.text) + '</span>' +
                    '<button type="button" class="cf-select-tag-remove"><i class="fa-solid fa-xmark"></i></button>';
                ctx.trigger.insertBefore(tag, arrow);
            });
        } else {
            // Single value
            var d = _findOption(ctx, ctx.selectedValues[0]);
            if (!d) return;
            var html = '';
            if (d.avatar) {
                html += '<img class="cf-opt-avatar" src="' + _escHtml(d.avatar) + '" alt="" style="width:22px;height:22px" />';
            } else if (d.icon) {
                html += '<span class="cf-opt-icon" style="width:20px;height:20px;font-size:10px"><i class="' + _escHtml(d.icon) + '"></i></span>';
            }
            html += '<span>' + _escHtml(d.text) + '</span>';

            var sv = document.createElement('div');
            sv.className = 'cf-select-single-value';
            sv.innerHTML = html;
            ctx.trigger.insertBefore(sv, ctx.trigger.querySelector('.cf-select-arrow'));
        }
    }

    // ?? Sync hidden inputs ??????????????????????????
    function _syncHidden(ctx) {
        if (ctx.opts.multiple || ctx.opts.freeTag) {
            var name = ctx.el.getAttribute('name') || ctx.el.id || '';
            ctx.hiddenContainer.innerHTML = '';
            ctx.selectedValues.forEach(function (val) {
                var inp = document.createElement('input');
                inp.type = 'hidden';
                inp.name = name;
                inp.value = val;
                ctx.hiddenContainer.appendChild(inp);
            });
        } else {
            if (ctx.hidden) ctx.hidden.value = ctx.selectedValues[0] || '';
        }
    }

    // ? Trigger change ����������������������
    function _triggerChange(ctx) {
        var val = (ctx.opts.multiple || ctx.opts.freeTag) ? ctx.selectedValues.slice() : (ctx.selectedValues[0] || null);
        if (typeof ctx.opts.onChange === 'function') {
            ctx.opts.onChange(val, ctx);
        }
    }

    // ?? Helpers ?????????????????????????????????????
    function _findOption(ctx, value) {
        return ctx.optionsData.find(function (d) { return d.value === value; }) || null;
    }

    function _escHtml(str) {
        if (!str) return '';
        var div = document.createElement('div');
        div.appendChild(document.createTextNode(str));
        return div.innerHTML;
    }

    // ?? Free tag - Add new tag from input ????????????
    function _addFreeTag(ctx, text) {
        // Skip duplicates
        if (ctx.selectedValues.indexOf(text) >= 0) return;

        // Add to optionsData so _findOption works for display
        if (!_findOption(ctx, text)) {
            ctx.optionsData.push({ value: text, text: text });
        }
        ctx.selectedValues.push(text);
        _syncDisplay(ctx);
        _syncHidden(ctx);
        _triggerChange(ctx);
    }

})(jQuery);
